'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import type { LOGIN_TYPE } from '@/api';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useMountAppData } from '../_hooks/useMountAppData';
import { dispatchAppEvent } from '../_utils/appEventBus';
import { type AppBridgeMessage, MESSAGE_KEYWORD, type MessageEvent, type MessageResponse } from '../_utils/reserved-keywords';
import type { FlutterInAppWebViewWindow } from '../_utils/window-types';
const isAppEventMessage = (message: AppBridgeMessage): message is MessageEvent => message.type === MESSAGE_KEYWORD.ADPOPCORN_SDK_EVENT || message.type === MESSAGE_KEYWORD.PINCRUX_REFRESH_BALANCE;
export const AppController = () => {
  const $ = _c(5);
  const setAppMessageLog = useDeviceInfoStore(_temp);
  const router = useCustomRouter();
  let t0;
  let t1;
  if ($[0] !== router || $[1] !== setAppMessageLog) {
    t0 = () => {
      const _window = window as FlutterInAppWebViewWindow;
      _window.router = {
        ...router,
        back: _temp2
      };
      const {
        setAppModal
      } = useDeviceInfoStore.getState();
      _window.openAppModal = type => {
        setAppModal({
          isOpened: true,
          type
        });
      };
      _window.postMessage = response => {
        const message = typeof response === "string" ? JSON.parse(response) : response;
        if (isAppEventMessage(message)) {
          dispatchAppEvent(message);
          return;
        }
        const responseObj = message;
        if (responseObj.isSuccess) {
          switch (responseObj.type) {
            case MESSAGE_KEYWORD.LOGIN:
              {
                const {
                  accessKey
                } = responseObj.data as {
                  accessKey: string;
                };
                router.push(ROUTES.AUTH.withSearchParams({
                  searchParams: {
                    "social-login-token": accessKey,
                    "login-type": responseObj.params?.loginType as LOGIN_TYPE
                  }
                }));
              }
          }
        }
        setAppMessageLog(prev => {
          prev.set(responseObj.id, responseObj);
          return prev;
        });
      };
    };
    t1 = [router, setAppMessageLog];
    $[0] = router;
    $[1] = setAppMessageLog;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  useMountAppData();
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <></>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(state) {
  return state.setAppMessageLog;
}
function _temp2() {}